/*!
 * Google maps configurations
 */
var $ = require('jquery');
require('./jquery.gm');

var projectConfig = window.projectConfig || {};
projectConfig.googlemaps = projectConfig.googlemaps || {};
projectConfig.googlemaps.activeMarker = null;

// create googlemap card
projectConfig.googlemaps.createCard = function(data) {
	return `
	<div class="live-mapa-info-container">
		<div class="live-mapa-info-contact">
			<div class="live-mapa-info-contact-icons">
				${data.customIcons}
			</div>
			<div class="live-mapa-info-contact-content">
				${data.bubbleContent}
			</div>
		</div>
	</div>`
;

};

// activate close button
projectConfig.googlemaps.detectStreetViewImage = function(marker, data) {

	if ( data.branchType == 'csas' ) {
		var $card = $('.googleMapCard', $(marker.container).parent());
		var url = 'https://maps.googleapis.com/maps/api/streetview/metadata?size=287x368&location=' + (data.lat).toString() + ',' + (data.lng).toString() + '&fov=90&heading=235&pitch=10&key=AIzaSyD1Arw77K0ngiTRnIkPosMJKZqYO3Ttowk';
		var imgUrl = '<img class="googleMapCardStreetViewThumbnail" src="https://maps.googleapis.com/maps/api/streetview?size=287x368&location=' + (data.lat).toString() + ',' + (data.lng).toString() + '&fov=90&heading=235&pitch=10&key=AIzaSyD1Arw77K0ngiTRnIkPosMJKZqYO3Ttowk" alt="" /><img class="googleMapCardMapThumbnail" src="/img/google-map/map-placeholder.jpg" alt="" /><button class="btn btn-inverse" id="gmapStreetViewTrigger">Street view</button><button class="btn" id="gmapMapTrigger">Mapa</button>';

		$.getJSON( url, function(jsonData) {
			if (jsonData.status == 'OK') {
				$('.googleMapCardStreetViewCnt', $card).html(imgUrl);
				$('.googleMapCardMapThumbnail, #gmapMapTrigger').hide();
				$('.googleMapCardStreetViewThumbnail', $card).on('load', function() {
					if ( $('#gmapMapTrigger').is(':hidden') ) {
						$('.googleMapCardStreetViewCnt #gmapStreetViewTrigger', $card).fadeIn();
					}
				});

				var panorama = marker.map.getStreetView();

				var latLng = new google.maps.LatLng(data.lat, data.lng);
				panorama.setPosition(latLng);
				panorama.setPov({
					heading: 0,
					pitch: 0
				});

				var pointerPanoramaOn = document.getElementById( "gmapStreetViewTrigger" );
				google.maps.event.addDomListener(pointerPanoramaOn, 'click', showPanorama);

				var pointerPanoramaOff = document.getElementById( "gmapMapTrigger" );
				google.maps.event.addDomListener(pointerPanoramaOff, 'click', hidePanorama);

				function showPanorama() {
					panorama.setVisible(true);
					$('.googleMapCardStreetViewThumbnail, #gmapStreetViewTrigger').hide();
					$('.googleMapCardMapThumbnail').css({'display' : 'block'});
					$('#gmapMapTrigger').show();
				}

				function hidePanorama() {
					panorama.setVisible(false);
					$('.googleMapCardMapThumbnail, #gmapMapTrigger').hide();
					$('.googleMapCardStreetViewThumbnail').css({'display' : 'block'});
					$('#gmapStreetViewTrigger').show();
				}

			} else {
				$('.googleMapCardStreetViewCnt', $card).html('<div class="withoutStreetView"><img src="/img/google-map/without-streetview.png" alt="" /></div>');
			}
		});
		//var map = new google.maps.Map(document.getElementById('googleMap'));
		//console.log(marker.map);
	}
};

// vyhledávání nad mapou
projectConfig.googlemaps.handleSearchInput = function() {
	$(document).on('submit', '.gmapServiceForm', function(e) {
		e.preventDefault();
		var gmapInputText = $('input[type="text"]', this).val();
		var bounds = new google.maps.LatLngBounds();

		dataLayer .push({
			'event': 'fgWebAnalytics',
			'fgVarType': '',
			'fgVarCat': 'Mapa',
			'fgVarAct': 'Vyhledávání',
			'fgVarLbl': gmapInputText,
			'fgVarTxt': ''
		});

		if ( !!$('#branches').length ) {
			scrollToAnchor( '#branches' );
		}

		// console.log(gmapInputText);

		$('#googleMap').googlemap("filterObjects", "markers", {}, {
			fulltextData: [gmapInputText]
		}, {
			onMarkerSuccess: function(marker) {
				bounds.extend(marker.position);

				setTimeout(function() {
					$('#googleMap').googlemap('zoomToMarkersBoundsCustom', bounds);
				}, 1000);

				//(marker.container).fitBounds(bounds);
				//projectConfig.googlemaps.resizeMapOnEvent();
				//$('#googleMap').googlemap('zoomToMarkersBounds', 0);
				/*var newIcon = $.extend(true, {}, marker.icon);
				newIcon.url = '/img/u/googlemap/markers.png';
				marker.setIcon(newIcon);*/
				/*$(marker.container).googlemap('setCenterAndZoom', {
					lat: 49.7701842,
					lng: 15.6009503,
					zoom: 8
				});*/
			}
		});
	});
};

projectConfig.googlemaps.handleCloseCard = function(marker, inactiveIcon) {
	var $card = $('.googleMapCard', $(marker.container).parent());
	$('.googleMapCardClose', $card).bind('click', function() {
		//projectConfig.googlemaps.activeMarker = projectConfig.googlemaps.setMarkerIcon(marker, false);
		projectConfig.googlemaps.activeIcon.setOptions({
			icon: inactiveIcon
		});
		marker.opened = false;
		$card.empty().hide();
	});
};

projectConfig.googlemaps.resizeMapOnEvent = function($coords) {
	var activeMap = $coords.activeMap || $('#googleMap');
	if (window.innerWidth <= 348) {
		activeMap.googlemap('setCenterAndZoom', {
			lat: $coords.lat,
			lng: $coords.lng,
			zoom: (($coords.zoomMin) ? $coords.zoomMin : 6)
		});
	} else if ((window.innerWidth >= 359) && (window.innerWidth <= 659)) {
		activeMap.googlemap('setCenterAndZoom', {
			lat: $coords.lat,
			lng: $coords.lng,
			zoom: (($coords.zoom659) ? $coords.zoom659 : 8)
		});
	} else if ((window.innerWidth >= 660) && (window.innerWidth <= 1052)) {
		activeMap.googlemap('setCenterAndZoom', {
			lat: $coords.lat,
			lng: $coords.lng,
			zoom: (($coords.zoom1052) ? $coords.zoom1052 : 10)
		});
	} else if (window.innerWidth >= 1053) {
		activeMap.googlemap('setCenterAndZoom', {
			lat: $coords.lat,
			lng: $coords.lng,
			zoom: (($coords.zoomMax) ? $coords.zoomMax : 12)
		});
	}
};

projectConfig.googlemaps.resizeMapServiceOnEvent = function($coords) {
	if (window.innerWidth <= 768) {
		$('#googleMap').googlemap('setCenterAndZoom', {
			lat: $coords.lat,
			lng: $coords.lng,
			zoom: (($coords.zoomMin) ? $coords.zoomMin : 6)
		});
	} else {
		$('#googleMap').googlemap('setCenterAndZoom', {
			lat: $coords.lat,
			lng: $coords.lng,
			zoom: (($coords.zoom659) ? $coords.zoom659 : 7)
		});
	}
};

window.projectConfig = projectConfig;




// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/googlemaps-config.js